const getters = {
  getDownloadUrl: state => state.user.downloadUrl,
}

export default getters
